<template>
<div class="chapter">
<div class="inner_page">
<p class="p5"><i></i> </p>
<p class="p4">This one is for the readers,<span class="s1"> <br/><br/></span></p>
<p class="p4">those wonderful time travelers<span class="s1"> <br/><br/></span>…</p>
<p class="p4">You know who you are</p>
<p class="p5"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section5.vue?04bd663d